import React, { ReactNode, MouseEvent } from 'react';

import PropTypes from 'prop-types';
import { CSSProp } from 'styled-components';

import { RenderIconType } from '@adsk/alloy-react-icon';
import { MenuItem } from '@adsk/alloy-react-menu';
import theme from '@adsk/alloy-react-theme';

import UnstyledAnchor from './UnstyledAnchor';

const EntityMenuItem = ({
  className,
  style,
  label,
  link,
  renderIcon,
  onClick,
}: {
  className?: string;
  style?: CSSProp;
  link?: string;
  onClick?: (e: MouseEvent) => void;
  renderIcon?: RenderIconType;
  label: ReactNode | string;
}) => (
  <MenuItem
    as={link ? UnstyledAnchor : 'button'}
    label={label}
    onClick={(e) => {
      e.stopPropagation(); // DO NOT REMOVE - Fix for LinkedReferencesCell within MatrixTable [WPX-967]
      onClick?.(e);
    }}
    href={link}
    target="_blank"
    className={className}
    style={[{ svg: { color: theme.colors.charcoal600 } }, style]}
    renderIcon={renderIcon}
    showSelection={false}
  />
);

EntityMenuItem.propTypes = {
  /**
   * Class to add to the component
   */
  className: PropTypes.string,
  /**
   * Styles applied to the component
   * */
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  /**
   * The title of the entity.
   */
  label: PropTypes.node.isRequired,
  /**
   * the link to be opened when clicking
   */
  link: PropTypes.string,
  /**
   * the onClick function
   */
  onClick: PropTypes.func,
  /**
   *  Render prop for icon to display on left
   */
  renderIcon: PropTypes.func,
};

export default EntityMenuItem;
